<section class="home">
  <div class="home-content">
    <div class="home-heading">Welcome in</div>

    @if (logoPath) {
      <img
        class="home-logo"
        [src]="logoPath"
        [alt]="companyName || 'Gateway logo'"
        (error)="onLogoError()"
      />
    }

    <div class="home-tagline">{{ tagline }}</div>

    <div class="home-version">v. {{ appVersion }}</div>

    <div class="home-quote">{{ quote }}</div>
  </div>
</section>
